import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-studio-slide',
  templateUrl: 'slide.component.html'
})
export class StudioSlideComponent {
  @Input() item: any = {};
  @Input() setting: any;

  constructor(
  ) {
  }

}
